<div class="qaroni-title-dashboard-container w-full">
  <h1 class="qaroni-title-dashboard mb-0">
    <ng-content />
  </h1>
</div>
